import { render, staticRenderFns } from "./SalesOrderViewAddInvoiceForm.vue?vue&type=template&id=2ba73343&scoped=true"
import script from "./SalesOrderViewAddInvoiceForm.vue?vue&type=script&lang=js"
export * from "./SalesOrderViewAddInvoiceForm.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderViewAddInvoiceForm.vue?vue&type=style&index=0&id=2ba73343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba73343",
  null
  
)

export default component.exports